import { initializeApp } from "firebase/app";
import { react } from "@babel/types";
import { getDatabase, ref, push, onValue } from "firebase/database";
import signcss from "./signup.css";
import Header from "../Header";
import React, { useEffect } from "react";
import Login from "./Login";
import reactDom from "react-dom";
import verified from "../imgs/check.png";
import { Guarantordetails } from "../request/Request";
import { useFlutterwave } from "flutterwave-react-v3";
import emailjs from "@emailjs/browser";
import { getStorage, ref as ref2 } from "firebase/storage";
import { uploadBytes, getDownloadURL } from "firebase/storage";
import verify from "../imgs/verify.png";
import { useState } from 'react';

const firebaseConfig = {
  apiKey: "AIzaSyBk-m6q2o1dKuggqoNxjoKZHmXeMSHhjsA",
  authDomain: "PROJECT_ID.firebaseapp.com",
  databaseURL: "https://househelps2-default-rtdb.firebaseio.com/",
  projectId: "househelps2",
  storageBucket: "househelps2.appspot.com",
  messagingSenderId: "SENDER_ID",
  appId: "APP_ID",
};



const LocalGovernmentsInput = () => { 
  const [selectedState, setSelectedState] = useState('');
  const [selectedLocalGov, setSelectedLocalGov] = useState('');

  const localGovernmentsNigeria = {
    // Add your local governments data here...
    Lagos:['Agege',
    'Ajeromi-Ifelodun',
    'Alimosho',
    'Amuwo-Odofin',
    'Apapa',
    'Badagry',
    'Epe',
    'Eti-Osa',
    'Ibeju-Lekki',
    'Ifako-Ijaiye',
    'Ikeja',
    'Ikorodu',
    'Kosofe',
    'Lagos Island',
    'Lagos Mainland',
    'Mushin',
    'Ojo',
    'Oshodi-Isolo',
    'Shomolu',
    'Surulere'
  ],
  Abuja:['Anka',
  'Bakura',
  'Birnin Magaji/Kiyaw',
  'Bukkuyum',
  'Bungudu',
  'Chafe',
  'Gummi',
  'Gusau',
  'Isa',
  'Kaura Namoda',
  'Maradun',
  'Maru',
  'Shinkafi',
  'Talata Mafara',
  'Zurmi'],
  Abia: [
    'Aba North',
    'Aba South',
    'Arochukwu',
    'Bende',
    'Ikwuano',
    'Isiala Ngwa North',
    'Isiala Ngwa South',
    'Isuikwuato',
    'Obi Ngwa',
    'Ohafia',
    'Osisioma Ngwa',
    'Ugwunagbo',
    'Ukwa East',
    'Ukwa West',
    'Umuahia North',
    'Umuahia South',
    'Umu Nneochi'
  ],
  Adamawa: [
    'Demsa',
    'Fufore',
    'Ganye',
    'Girei',
    'Gombi',
    'Guyuk',
    'Hong',
    'Jada',
    'Lamurde',
    'Madagali',
    'Maiha',
    'Mayo-Belwa',
    'Michika',
    'Mubi North',
    'Mubi South',
    'Numan',
    'Shelleng',
    'Song',
    'Toungo',
    'Yola North',
    'Yola South'
  ],
  "Akwa-Ibom":[
    'Abak',
    'Eastern Obolo',
    'Eket',
    'Esit-Eket',
    'Essien Udim',
    'Etim-Ekpo',
    'Etinan',
    'Ibeno',
    'Ibesikpo-Asutan',
    'Ibiono-Ibom',
    'Ika',
    'Ikono',
    'Ikot Abasi',
    'Ikot Ekpene',
    'Ini',
    'Itu',
    'Mbo',
    'Mkpat-Enin',
    'Nsit-Atai',
    'Nsit-Ibom',
    'Nsit-Ubium',
    'Obot-Akara',
    'Okobo',
    'Onna',
    'Oron',
    'Oruk Anam',
    'Ukanafun',
    'Udung-Uko',
    'Uruan',
    'Urue-Offong/Oruko',
    'Uyo',
  ],
  Anambara:[
    'Aguata',
  'Anambra East',
  'Anambra West',
  'Anaocha',
  'Awka North',
  'Awka South',
  'Ayamelum',
  'Dunukofia',
  'Ekwusigo',
  'Idemili North',
  'Idemili South',
  'Ihiala',
  'Njikoka',
  'Nnewi North',
  'Nnewi South',
  'Ogbaru',
  'Onitsha North',
  'Onitsha South',
  'Orumba North',
  'Orumba South',
  'Oyi',
  ],
  Bauchi:[ 'Alkaleri',
  'Bauchi',
  'Bogoro',
  'Damban',
  'Darazo',
  'Dass',
  'Gamawa',
  'Ganjuwa',
  'Giade',
  'Itas/Gadau',
  'Jama\'are',
  'Katagum',
  'Kirfi',
  'Misau',
  'Ningi',
  'Shira',
  'Tafawa Balewa',
  'Toro',
  'Warji',
  'Zaki',],
  Bayelsa:['Brass',
  'Ekeremor',
  'Kolokuma/Opokuma',
  'Nembe',
  'Ogbia',
  'Sagbama',
  'Southern Ijaw',
  'Yenagoa',],
  Benue:[  'Ado',
  'Agatu',
  'Apa',
  'Buruku',
  'Gboko',
  'Guma',
  'Gwer East',
  'Gwer West',
  'Katsina-Ala',
  'Konshisha',
  'Kwande',
  'Logo',
  'Makurdi',
  'Obi',
  'Ogbadibo',
  'Ohimini',
  'Oju',
  'Okpokwu',
  'Otukpo',
  'Tarka',
  'Ukum',
  'Ushongo',
  'Vandeikya',],
  Borno:['Abadam',
  'Askira/Uba',
  'Bama',
  'Bayo',
  'Biu',
  'Chibok',
  'Damboa',
  'Dikwa',
  'Gubio',
  'Guzamala',
  'Gwoza',
  'Hawul',
  'Jere',
  'Kaga',
  'Kala/Balge',
  'Konduga',
  'Kukawa',
  'Kwaya Kusar',
  'Mafa',
  'Magumeri',
  'Maiduguri',
  'Marte',
  'Mobbar',
  'Monguno',
  'Ngala',
  'Nganzai',
  'Shani',
],
  "Cross-River":['Akpabuyo',
  'Akpamkpa',
  'Bakassi',
  'Bekwarra',
  'Biase',
  'Boki',
  'Calabar Municipal',
  'Calabar South',
  'Etung',
  'Ikom',
  'Obanliku',
  'Obubra',
  'Obudu',
  'Odukpani',
  'Ogoja',
  'Yakuur',
  'Yala',],
  Delta:['Aniocha North',
  'Aniocha South',
  'Bomadi',
  'Burutu',
  'Ethiope East',
  'Ethiope West',
  'Ika North East',
  'Ika South',
  'Isoko North',
  'Isoko South',
  'Ndokwa East',
  'Ndokwa West',
  'Okpe',
  'Oshimili North',
  'Oshimili South',
  'Patani',
  'Sapele',
  'Udu',
  'Ughelli North',
  'Ughelli South',
  'Ukwuani',
  'Uvwie',
  'Warri North',
  'Warri South',
  'Warri South West',],
  Ebonyi:['Abakaliki',
  'Afikpo North',
  'Afikpo South (Edda)',
  'Ebonyi',
  'Ezza North',
  'Ezza South',
  'Ikwo',
  'Ishielu',
  'Ivo',
  'Izzi',
  'Ohaozara',
  'Ohaukwu',
  'Onicha',],
  Edo :['Akoko-Edo',
  'Egor',
  'Esan Central',
  'Esan North-East',
  'Esan South-East',
  'Esan West',
  'Etsako Central',
  'Etsako East',
  'Etsako West',
  'Igueben',
  'Ikpoba-Okha',
  'Oredo',
  'Orhionmwon',
  'Ovia North-East',
  'Ovia South-West',
  'Owan East',
  'Owan West',
  'Uhunmwonde'],
  Ekiti:[ 'Ado-Ekiti',
  'Efon',
  'Ekiti East',
  'Ekiti South-West',
  'Ekiti West',
  'Emure',
  'Gbonyin',
  'Ido-Osi',
  'Ijero',
  'Ikere',
  'Ikole',
  'Ilejemeje',
  'Irepodun/Ifelodun',
  'Ise/Orun',
  'Moba',
  'Oye'],
  Enugu:['Aninri',
  'Awgu',
  'Enugu East',
  'Enugu North',
  'Enugu South',
  'Ezeagu',
  'Igbo Etiti',
  'Igbo Eze North',
  'Igbo Eze South',
  'Isi Uzo',
  'Nkanu East',
  'Nkanu West',
  'Nsukka',
  'Oji River',
  'Udenu',
  'Udi',
  'Uzo-Uwani'],
  Gombe:['Akko',
  'Balanga',
  'Billiri',
  'Dukku',
  'Funakaye',
  'Gombe',
  'Kaltungo',
  'Kwami',
  'Nafada',
  'Shongom',
  'Yamaltu/Deba'],
  Imo:['Aboh-Mbaise',
  'Ahiazu-Mbaise',
  'Ehime-Mbano',
  'Ezinihitte',
  'Ideato North',
  'Ideato South',
  'Ihitte/Uboma',
  'Ikeduru',
  'Isiala Mbano',
  'Isu',
  'Mbaitoli',
  'Ngor-Okpala',
  'Njaba',
  'Nkwerre',
  'Nwangele',
  'Obowo',
  'Oguta',
  'Ohaji/Egbema',
  'Okigwe',
  'Onuimo',
  'Orlu',
  'Orsu',
  'Oru East',
  'Oru West',
  'Owerri Municipal',
  'Owerri North',
  'Owerri West'],
  Jigawa:[ 'Auyo',
  'Babura',
  'Biriniwa',
  'Birnin Kudu',
  'Buji',
  'Dutse',
  'Gagarawa',
  'Garki',
  'Gumel',
  'Guri',
  'Gwaram',
  'Gwiwa',
  'Hadejia',
  'Jahun',
  'Kafin Hausa',
  'Kazaure',
  'Kiri Kasama',
  'Kiyawa',
  'Kaugama',
  'Maigatari',
  'Malam Madori',
  'Miga',
  'Ringim',
  'Roni',
  'Sule Tankarkar',
  'Taura',
  'Yankwashi'],
  Kaduna:['Birnin Gwari',
  'Chikun',
  'Giwa',
  'Igabi',
  'Ikara',
  'Jaba',
  'Jema\'a',
  'Kachia',
  'Kaduna North',
  'Kaduna South',
  'Kagarko',
  'Kajuru',
  'Kaura',
  'Kauru',
  'Kubau',
  'Kudan',
  'Lere',
  'Makarfi',
  'Sabon Gari',
  'Sanga',
  'Soba',
  'Zangon Kataf',
  'Zaria'],
  Kano:['Ajingi',
  'Albasu',
  'Bagwai',
  'Bebeji',
  'Bichi',
  'Bunkure',
  'Dala',
  'Dambatta',
  'Dawakin Kudu',
  'Dawakin Tofa',
  'Doguwa',
  'Fagge',
  'Gabasawa',
  'Garko',
  'Garum Mallam',
  'Gezawa',
  'Gwale',
  'Gwarzo',
  'Kabo',
  'Kano Municipal',
  'Karaye',
  'Kibiya',
  'Kiru',
  'Kumbotso',
  'Kunchi',
  'Kura',
  'Madobi',
  'Makoda',
  'Minjibir',
  'Nasarawa',
  'Rano',
  'Rimin Gado',
  'Rogo',
  'Shanono',
  'Sumaila',
  'Takai',
  'Tarauni',
  'Tofa',
  'Tsanyawa',
  'Tudun Wada',
  'Ungogo',
  'Warawa',
  'Wudil'
],
  Katsina:[ 'Bakori',
  'Batagarawa',
  'Batsari',
  'Baure',
  'Bindawa',
  'Charanchi',
  'Dan Musa',
  'Dandume',
  'Danja',
  'Daura',
  'Dutsi',
  'Dutsin-Ma',
  'Faskari',
  'Funtua',
  'Ingawa',
  'Jibia',
  'Kafur',
  'Kaita',
  'Kankara',
  'Kankia',
  'Katsina',
  'Kurfi',
  'Kusada',
  'MaiAdua',
  'Malumfashi'],
  Kebbi:['Aleiro',
  'Arewa Dandi',
  'Argungu',
  'Augie',
  'Bagudo',
  'Birnin Kebbi',
  'Bunza',
  'Dandi',
  'Fakai',
  'Gwandu',
  'Jega',
  'Kalgo',
  'Koko/Besse',
  'Maiyama',
  'Ngaski',
  'Sakaba',
  'Shanga',
  'Suru',
  'Wasagu/Danko',
  'Yauri',
  'Zuru',],
  Kogi:['Adavi',
  'Ajaokuta',
  'Ankpa',
  'Bassa',
  'Dekina',
  'Ibaji',
  'Idah',
  'Igalamela-Odolu',
  'Ijumu',
  'Kabba/Bunu',
  'Kogi',
  'Lokoja',
  'Mopa-Muro',
  'Ofu',
  'Ogori/Magongo',
  'Okehi',
  'Okene',
  'Olamaboro',
  'Omala',
  'Yagba East',
  'Yagba West',
],
  Kwara:['Asa',
  'Baruten',
  'Edu',
  'Ekiti',
  'Ifelodun',
  'Ilorin East',
  'Ilorin South',
  'Ilorin West',
  'Irepodun',
  'Isin',
  'Kaiama',
  'Moro',
  'Offa',
  'Oke Ero',
  'Oyun',
  'Pategi',],
  Nasarawa:['Awe',
  'Doma',
  'Karu',
  'Keana',
  'Keffi',
  'Kokona',
  'Lafia',
  'Nasarawa',
  'Nasarawa Egon',
  'Obi',
  'Toto',
  'Wamba'],
  Niger:['Agaie',
  'Agwara',
  'Bida',
  'Borgu',
  'Bosso',
  'Chanchaga',
  'Edati',
  'Gbako',
  'Gurara',
  'Katcha',
  'Kontagora',
  'Lapai',
  'Lavun',
  'Magama',
  'Mariga',
  'Mashegu',
  'Mokwa',
  'Moya',
  'Paikoro',
  'Rafi',
  'Rijau',
  'Shiroro',
  'Suleja',
  'Tafa',
  'Wushishi',],
  Ogun:['Abeokuta North',
  'Abeokuta South',
  'Ado-Odo/Ota',
  'Egbado North',
  'Egbado South',
  'Ewekoro',
  'Ifo',
  'Ijebu East',
  'Ijebu North',
  'Ijebu North East',
  'Ijebu Ode',
  'Ikenne',
  'Imeko Afon',
  'Ipokia',
  'Obafemi Owode',
  'Odeda',
  'Odogbolu',
  'Ogun Waterside',
  'Remo North',
  'Shagamu'],
  Ondo:[ 'Akoko North-East',
  'Akoko North-West',
  'Akoko South-East',
  'Akoko South-West',
  'Akure North',
  'Akure South',
  'Ese Odo',
  'Idanre',
  'Ifedore',
  'Ilaje',
  'Ile Oluji/Okeigbo',
  'Irele',
  'Odigbo',
  'Okitipupa',
  'Ondo East',
  'Ondo West',
  'Ose',
  'Owo'],
  Osun:[ 'Aiyedade',
  'Aiyedire',
  'Atakunmosa East',
  'Atakunmosa West',
  'Boluwaduro',
  'Boripe',
  'Ede North',
  'Ede South',
  'Egbedore',
  'Ejigbo',
  'Ife Central',
  'Ife East',
  'Ife North',
  'Ife South',
  'Ifedayo',
  'Ifelodun',
  'Ila',
  'Ilesa East',
  'Ilesa West',
  'Irepodun',
  'Irewole',
  'Isokan',
  'Iwo',
  'Obokun',
  'Odo Otin',
  'Ola Oluwa',
  'Olorunda',
  'Oriade',
  'Orolu',
  'Osogbo'
],
  Plateau:[ 'Barkin Ladi',
  'Bassa',
  'Bokkos',
  'Jos East',
  'Jos North',
  'Jos South',
  'Kanam',
  'Kanke',
  'Langtang North',
  'Langtang South',
  'Mangu',
  'Mikang',
  'Pankshin',
  'Quaan Pan',
  'Riyom',
  'Shendam',
  'Wase'],
  Rivers:[ 'Abua/Odual',
  'Ahoada East',
  'Ahoada West',
  'Akuku-Toru',
  'Andoni',
  'Asari-Toru',
  'Bonny',
  'Degema',
  'Emohua',
  'Eleme',
  'Etche',
  'Gokana',
  'Ikwerre',
  'Khana',
  'Obio/Akpor',
  'Ogba/Egbema/Ndoni',
  'Ogu/Bolo',
  'Okrika',
  'Omuma',
  'Opobo/Nkoro',
  'Oyigbo',
  'Port Harcourt',
  'Tai'
],
  Sokoto:[ 'Binji',
  'Bodinga',
  'Dange-Shuni',
  'Gada',
  'Goronyo',
  'Gudu',
  'Gwadabawa',
  'Illela',
  'Isa',
  'Kebbe',
  'Kware',
  'Rabah',
  'Sabon Birni',
  'Shagari',
  'Silame',
  'Sokoto North',
  'Sokoto South',
  'Tambuwal',
  'Tangaza',
  'Tureta',
  'Wamako',
  'Wurno',
  'Yabo'],
  Taraba:['Ardo Kola',
  'Bali',
  'Donga',
  'Gashaka',
  'Gassol',
  'Ibi',
  'Jalingo',
  'Karim Lamido',
  'Kumi',
  'Lau',
  'Sardauna',
  'Takum',
  'Ussa',
  'Wukari',
  'Yorro',
  'Zing'],
  Yobe:['Bade',
  'Bursari',
  'Damaturu',
  'Fika',
  'Fune',
  'Geidam',
  'Gujba',
  'Gulani',
  'Jakusko',
  'Karasuwa',
  'Machina',
  'Nangere',
  'Nguru',
  'Potiskum',
  'Tarmuwa',
  'Yunusari',
  'Yusufari'],
  Zamfara:[ 'Anka',
  'Bakura',
  'Birnin Magaji/Kiyaw',
  'Bukkuyum',
  'Bungudu',
  'Chafe',
  'Gummi',
  'Gusau',
  'Isa',
  'Kaura Namoda',
  'Maradun',
  'Maru',
  'Shinkafi',
  'Talata Mafara',
  'Zurmi'],
 
  };

  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setSelectedLocalGov('');
  };

  const handleLocalGovChange = (event) => {
    setSelectedLocalGov(event.target.value);
  };

  return (
    <div >
      {/* <br></br>? */}
      <label style={{margin:"20px", fontWeight:"bold",padding:"12px"}}>
        Select State of Residence:&nbsp;&nbsp;<br></br><br></br>
        <select style={{padding:"10px",fontSize:"1em"}} id="addressState" value={selectedState} onChange={handleStateChange}>
        <option value="Abia"> Abia</option>
            <option value="Abuja">Abuja</option>
            <option value="Adamawa">Adamawa </option>
            <option value="Akwa-Ibom"> Akwa-Ibom</option>
            <option value="Anambara">Anambra</option>
            <option value="Bauchi">Bauchi</option>
            <option value="Bayelsa">Bayelsa</option>
            <option value="Benue">Benue </option>
            <option value="Borno">Borno</option>
            <option value="Cross River"> Cross River </option>
            <option value="Delta">Delta </option>
            <option value="Ebonyi">Ebonyi </option>
            <option value="Edo"> Edo </option>
            <option value="Ekiti"> Ekiti</option>
            <option value="Enugu">Enugu </option>
            <option value="Gombe">Gombe </option>
            <option value="Imo">Imo</option>
            <option value="Jigawa"> Jigawa</option>
            <option value="Kaduna">Kaduna</option>
            <option value="Kano">Kano</option>
            <option value="Katsina">Katsina</option>
            <option value="Kebbi"> Kebbi </option>
            <option value="Kogi">Kogi </option>
            <option value="Kwara">Kwara</option>
            <option value="Lagos">Lagos</option>
            <option value="Nasarawa"> Nasarawa</option>
            <option value="Niger">Niger</option>
            <option value="Ogun">Ogun</option>
            <option value="Ondo">Ondo</option>
            <option value="Osun"> Osun</option>
            <option value="Oyo">Oyo </option>
            <option value="Plateau">Plateau</option>
            <option value="Rivers">Rivers </option>
            <option value="Sokoto"> Sokoto</option>
            <option value="Taraba">Taraba </option>
            <option value="Yobe">Yobe</option>
            <option value="Zamfara">Zamfara</option>
          {Object.keys(localGovernmentsNigeria).map((state) => (
            <option key={state} value={state}>
              {state}
            </option>
          ))}
        </select>
      </label>
      {selectedState && (
        <label>
          Select Local Government:&nbsp;&nbsp;<br></br><br></br>
          <select id="Addresslocalgovernment" value={selectedLocalGov} onChange={handleLocalGovChange}>
            <option value="">Select Local Government</option>
            {localGovernmentsNigeria[selectedState].map((lg, index) => (
              <option key={index} value={lg}>
                {lg}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
};




function Signup() {
  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const db = getDatabase();
    var arrayofemails = [];
    var logologo = document.querySelector("#logo-logo");

    function writeUserData(
      firstname,
      lastname,
      url,
      email,
      password,
      DOB,
      SOO,
      jobtype,
      pnumber,
      Age,
      address,
      localgovernment,
      addressState
    ) {
      sessionStorage.setItem("hname", firstname + lastname);
      sessionStorage.setItem("hemail", email);
      sessionStorage.setItem("hpnumber", pnumber);

      push(ref(db, "/users"), {
        firstname: firstname,
        lastname: lastname,
        image: url,
        email: email,
        password: password,
        DOB: DOB,
        SOO: SOO,
        jobtype: jobtype,
        pnumber: pnumber,
        Age: Age,
        address: address,
        localgovernment:localgovernment,
        addressState:addressState
      })
        .then(() => {
          var templateParams = {
            Help_name: `${firstname} ${lastname}`,
            //Todo: change below client_email value to clients email i.e userData.email the value below was used for testing
            Help_email: email,
            Help_pnumber: `${pnumber}`,
            Help_age: Age,
            Help_SOO: SOO,
            Help_jobtype: jobtype,
            Help_Address: address,
            Help_image: url,
          };

          emailjs.send(
            process.env.REACT_APP_SERVICE_ID2,
            process.env.REACT_APP_TEMPLATE_ID2,
            templateParams,
            process.env.REACT_APP_USER_ID2
          );
          console.log("email");
          console.log(firstname, lastname);
          document.querySelector("#firstname").value = "";
          document.querySelector("#lastname").value = "";
          document.querySelector("#email").value = "";
          document.querySelector("#password").value = "";
          document.querySelector("#n2").innerHTML = "Data Sent Successfully ";
          var logologo = document.querySelector("#logo-logo");

          renderGuarantor();
        })
        .catch((error) => {});
    }
    const starCountRef = ref(db, "users/");
    onValue(starCountRef, (snapshot) => {
      snapshot.forEach((element) => {
        var data = element.val();

        arrayofemails.push(data.email);
      });
      console.log(arrayofemails);
    });

    logologo.style.display = "none";

    

    var signup_submit_button = document.querySelector("#signup_submit_button");
    
    signup_submit_button.addEventListener("click",(e)=>{
      e.preventDefault()
      navigator.geolocation.getCurrentPosition((position) => {
        console.log(position.coords.latitude, position.coords.longitude);
      });
      console.log("click")

      function getformdata(arrayofemails,firstname,lastname,email,password,DateOFBirth,SOO,jobtype,pnumber,Age,address,product_file,display,
        addressstate ,localgovernment ) {
      
        const db = getDatabase();
        const storage = getStorage();
  
    // const db = getDatabase();
    const productRef = ref(db, "/products");
  
        if (
          firstname !== "" &&
          lastname !== "" &&
          product_file.value !== "" &&
          email !== "" &&
          email.includes("@") &&
          email.includes(".") &&
          password !== "" &&
          Age !== "" &&
          pnumber !== "" &&
          SOO !== "" &&
          DateOFBirth !== "" &&
          addressstate!=="" &&
          localgovernment!==""
        ) {
          var boolean = 0;
  
          var picture = Array.from(product_file.files);
          var picture1 = picture[0];
  
          console.log(picture1);
          for (var i = 0; i <= arrayofemails.length; i++) {
            if (arrayofemails[i] == email) {
              boolean++;
            }
          }
  
          if (boolean == 0) {
            sessionStorage.setItem("Applicantname", firstname + " " + lastname);
            sessionStorage.setItem("Applicantemail", email);
  
            console.log(picture1.type);
            var file = picture1;
  
            var locationStorage = ref2(storage, firstname + lastname);
            const metadata = {
              contentType: "image/jpeg",
            };
  
            const uploadTask = uploadBytes(locationStorage, file, metadata);
            document.querySelector(
              "#signupform"
            ).innerHTML = `<h1 >Loading... </h1>`;
            uploadTask
              .then((snapshot) => {
                console.log("photo uploaded successfully", snapshot);
                const durl = getDownloadURL(
                  ref2(storage, "/" + firstname + lastname)
                );
                durl.then((url) => {
                  display.src = url;
                  console.log(url);
  
                  writeUserData(
                    firstname,
                    lastname,
                    url,
                    email,
                    password,
                    DateOFBirth,
                    SOO,
                    jobtype,
                    pnumber,
                    Age,
                    address,
                    addressstate,
                    localgovernment
                  );
                  renderGuarantor();
                });
              })
              .then((response) => {});
  
            logologo.style.display = "block";
          } else {
            document.querySelector("#n2").style.color = "red";
            document.querySelector("#n2").innerHTML = "Email Already in Use ";
          }
        } else {
          console.log("one of the fields is Empty");
          console.log(firstname, lastname, email, password);
          document.querySelector("#n2").style.color = "red";
          document.querySelector("#n2").innerHTML =
            "failed to send one or more fields are left Blank or email is incorrect";
        }
      }

      
      var firstname = document.getElementById("Firstname").value;
        var lastname = document.querySelector("#lastname").value;
        var email = document.querySelector("#email").value;
        var password = document.querySelector("#password").value;
        var DateOFBirth = document.querySelector("#date").value;
        var SOO = document.querySelector("#state_of_origin").value;
        var jobtype = document.querySelector("#job_type").value;
        var pnumber = document.querySelector("#Pnumber").value;
        var Age = document.querySelector("#Age").value;
        var address = document.querySelector("#address").value;
        var product_file = document.querySelector("#file");
        var display = document.querySelector("#imgsrc");
        var localgovernment =document.querySelector("#Addresslocalgovernment").value
        var addressstate =document.querySelector("#addressState").value
        console.log(firstname,lastname,localgovernment,addressstate)

         getformdata(arrayofemails,firstname,lastname,email,password,DateOFBirth,SOO,jobtype,pnumber,Age,address,product_file,display,localgovernment,
          addressstate  )
    })
    

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log(position.coords.latitude, position.coords.longitude);
      });
      
    } else {
      /* geolocation IS NOT available */
    }
    
   
  });

  return (
    <div className="div" style={signcss}>
      <form style={{}}>
        <div id="signupform">
          <h1> Sign up</h1>
          <h2>Personal Information </h2>
          <p>Firstname</p>
          <input type="text"  className="" id="Firstname" required></input>
          <p> Lastname </p> <input type="text" id="lastname" required></input>
          <label htmlFor="product-picture">Face picture</label>
          <br></br>
          
          <br></br>
          <input type="file" id="file" required></input>
          <LocalGovernmentsInput/>
          <p> Address </p>{" "}
          <input
            type="text"
            id="address"
            placeholder="state,lga,bustop,street,house number"
            required></input>

            
          <p>Date Of Birth</p>
          <input type="date" id="date" required></input>
          <p>State Of Origin</p>
          <select
          
            name="State Of Origin"
            id="state_of_origin"
            form="state_of_origin">
            <option value=" Abia"> Abia</option>
            <option value="Abuja"> FCT Abuja</option>
            <option value="Adamawa ">Adamawa </option>
            <option value=" Akwa-Ibom"> Akwa-Ibom</option>
            <option value="anambara">Anambra</option>
            <option value="Bauchi">Bauchi</option>
            <option value="Bayelsa">Bayelsa</option>
            <option value="Benue">Benue </option>
            <option value="Borno">Borno</option>
            <option value="Cross River"> Cross River </option>
            <option value="Delta">Delta </option>
            <option value="Ebonyi">Ebonyi </option>
            <option value="Edo"> Edo </option>
            <option value="Ekiti"> Ekiti</option>
            <option value="Enugu">Enugu </option>
            <option value="Gombe">Gombe </option>
            <option value="Imo">Imo</option>
            <option value="Jigawa"> Jigawa</option>
            <option value="Kaduna">Kaduna</option>
            <option value="Kano">Kano</option>
            <option value="Katsina">Katsina</option>
            <option value="Kebbi"> Kebbi </option>
            <option value="Kogi">Kogi </option>
            <option value="Kwara">Kwara</option>
            <option value="Lagos">Lagos</option>
            <option value="Nasarawa"> Nasarawa</option>
            <option value="Niger">Niger</option>
            <option value="Ogun">Ogun</option>
            <option value="Ondo">Ondo</option>
            <option value="Osun"> Osun</option>
            <option value="Oyo">Oyo </option>
            <option value="Plateau">Plateau</option>
            <option value="Rivers">Rivers </option>
            <option value="Sokoto"> Sokoto</option>
            <option value="Taraba">Taraba </option>
            <option value="Yobe">Yobe</option>
            <option value="Zamfara">Zamfara</option>
          </select>
          <p>Job Type</p>
          <select name="Job Type" id="job_type" form="job_type" required>
            <option value="Partime"> Partime</option>
            <option value="Fulltime">Fulltime</option>
            <option value="Both">Both</option>
          </select>
          <p>Phone Number</p>
          <input type="number" id="Pnumber" required></input>
          <p>Age</p>
          <input type="Number" id="Age" required></input>
          <p> Email </p>
          <input type="email" id="email" required></input>
          <p>Password</p>
          <input type="password" id="password" required></input>
          <p></p>
          <div id="n2"></div>
          <div id="data"></div>
          <button value="Submit" id="signup_submit_button">
            Submit
          </button>
        </div>
      </form>
      {/* 
      <div id="n2"></div>
      <div id="data"></div> */}
      <img src="" id="imgsrc" width="300px"></img>
    </div>
  );
}

function SignupPaymentPage() {
  var amount = 1000;

  var Applicantname = sessionStorage.getItem("hname");
  var Applicantemail = sessionStorage.getItem("hemail");
  console.log(Applicantemail);

  var phonenumber = sessionStorage.getItem("pnumber1");
  var name = sessionStorage.getItem("name1");

  console.log(Applicantemail, phonenumber, Applicantname);

  var config = {
    public_key: "FLWPUBK-d414dfaf4d80cb19a871956045965e25-X",
    tx_ref: Date.now(),
    amount: Number(amount),
    //  amount: 20,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd,bank",
    customer: {
      email: sessionStorage.getItem("hemail"),
      phonenumber: phonenumber,
      name: Applicantemail,
    },
    customizations: {
      title: "@Househelp.ng",
      description: "Payment househelp to @househelp.ng",
      logo: "https://react-househelp.netlify.app/static/media/logo.4c7277c6.png",
    },
  };
  const handleFlutterPayment = useFlutterwave(config);

  return (
    <div>
      <div
        style={{
          textAlign: "center",
          border: "1px solid green",
          width: "95%",
          margin: "10px auto",
          padding: "10px",
        }}>
        <p style={{ borderBottom: "2px solid black" }}>
          {" "}
          Registration Fee <span> (non-refundable) </span> =N1000
        </p>
        {/* <p style={{borderBottom:"2px solid black"}}>  Request Fee =N1500</p> */}
        <p style={{ borderBottom: "2px solid black" }}>
          {" "}
          Total Amount Due =N 1,000
        </p>

        <button
          onClick={() => {
            handleFlutterPayment({
              callback: (response) => {
                console.log(response);

                //  closePaymentModal() // this will close the modal programmatically
                if (
                  response.status == "success" ||
                  response.data.status == "successful"
                ) {
                  window.location.href = "/fullPaymentcomplete";
                  //  renderFullPaymentComplete()
                }
              },
              onClose: () => {},
            });
          }}>
          Make Payments
        </button>
      </div>
    </div>
  );
}

function renderLogin() {
  reactDom.render(
    <div>
      <Header />
      <Login />
    </div>,
    document.querySelector("#root")
  );
}
function renderSignuppay() {
  reactDom.render(
    <div>
      <Header />
      <SignupPaymentPage />
    </div>,
    document.querySelector("#root")
  );
}

function renderGuarantor() {
  reactDom.render(
    <div>
      <Header />
      <Guarantordetails />
    </div>,
    document.querySelector("#root")
  );
}

export { Signup, SignupPaymentPage, renderSignuppay ,LocalGovernmentsInput};
